export default __webpack_public_path__ + "static/media/cif-sz.a1fec135.svg";